import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentGql } from './MetricsDisplayGridRowDataFragmentGql';

export const VirtualConnectionTableDownstreamMetricsFilteredByColumnQueryGql: DocumentNode = gql`
query VirtualConnectionTableDownstreamMetricsFilteredByColumnQuery(
  $vizportalUrlId: String!,
  $selectedColumnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: MetricSortOrder!
) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    columnsConnection(filter: { id: $selectedColumnId }) {
      nodes {
        downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...MetricsDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${MetricsDisplayGridRowDataFragmentGql}
`;
